import { isNotFound } from '@tanstack/react-router';
import { Skeleton } from '@worldcoo/ui/components/skeleton';
import { Suspense } from 'react';
import { Image } from '../../-components/image';
import { usePortalAuthorQuery } from '@/lib/queries';
import { getLogoImageSize } from '@/lib/shared';
import { usePortalContext } from '@/lib/use-portal-context';

export function Logo() {
	const { portalId } = usePortalContext();

	return (
		<Suspense fallback={<Skeleton className="bg-secondary" style={{ height: getLogoImageSize(portalId).height }} />}>
			<SuspensedLogo />
		</Suspense>
	);
}

function SuspensedLogo() {
	const { portalId } = usePortalContext();
	const author = usePortalAuthorQuery();

	if (isNotFound(author) || !author.logo) return;

	return (
		<Image
			src={author.logo.location}
			alt="Portal Logo"
			height={getLogoImageSize(portalId).height}
			// TODO: there is a lot of logos that doesn't have sizes defined, fix that
			aspectRatio={
				(author.logo.width && author.logo.height ? author.logo.width / author.logo.height : undefined) as number
			}
			fetchPriority="high"
			// The aspect ratio defined above could deform the image, so we force it to auto
			className="aspect-auto!"
		/>
	);
}
